import { Outlet } from "react-router-dom";
import HorizontalWrapper from "../components/HorizontalWrapper.js";

const MainLayout = () => {
  return (
    <div className=" mainLayout h-dvh overflow-hidden text-foreground">
      <HorizontalWrapper
        className={`flex px-0 md:px-0 lg:pr-8 overflow-hidden  h-full`}
      >
        <Outlet />
      </HorizontalWrapper>
      <div className={`h-24 md:hidden`} />
      <HorizontalWrapper
        id={`slideoutContainer`}
        className={`fixed inset-0 h-screen  z-50   overflow-hidden pointer-events-none`}
      />
    </div>
  );
};

export default MainLayout;
